/* eslint-disable */

import SearchBar from '../header-searchbar/index';
import { bus } from '@/main';
import {mapGetters} from 'vuex';

export default {
  name: 'header-after-login',
  components: {
    'search-bar': SearchBar
  },
  props: [],
  data() {
    return {
      profileInfoData:null,
      authBtnShowState:true
    }
  },
  computed: {
    ...mapGetters(['accountUserGetters']),
    isAuthenticated: () => {
      return this.$store.getters.login
    },
    getUserInfo() {
      this.profileInfoData = this.$store.getters.accountUserGetters.data;
      return;
    }
  },
  mounted() {
    this.getUserInfo
    bus.$on('authBtnShowBus', (data) => {
      this.authBtnShowState = data
    })
  },
  methods: {
    getImgUrl(pic) {
      if (pic == '' || !pic || pic == 'undefined') {
        return require('./../../assets/images/user2.png')
      } else {
        return pic
      }
    },
    handleScroll() {
      let header = document.querySelector(".header_fix");
      if (window.scrollY > 40 && !header.className.includes('darkBg')) {
        header.classList.add('darkBg');
      } else if (window.scrollY < 40) {
        header.classList.remove('darkBg');
      }
    },
    logout: function() {
      this.$store.dispatch('logout')
        .then(() => {
          localStorage.removeItem('token')
          this.$router.push('/login')
          delete axios.defaults.headers.common['Authorization']
        })
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  watch:{
    getUserInfo() {
      return this.$store.getters.accountUserGetters;
    }
  }
}